module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.ismenu) ? _c('el-menu', {
    staticClass: "el-menu1",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/main"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._l((_vm.menus), function(menu) {
    return _c('el-submenu', {
      key: menu.id,
      attrs: {
        "index": menu.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(menu.menu))]), _vm._v(" "), _vm._l((menu.items), function(item) {
      return _c('el-menu-item', {
        key: item.id,
        attrs: {
          "index": "item.id"
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            path: item.path
          }
        }
      }, [_vm._v(_vm._s(item.name))])], 1)
    })], 2)
  })], 2) : _c('el-menu', [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("EV Batteries Remote Monitoring System")])]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu2",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "11"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('b', [_vm._v("3")]), _c('span', [_vm._v("告警")])])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "12"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('span', [_vm._v("用户")])])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('span', [_vm._v("退出")])])], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "14"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "14-1"
    },
    on: {
      "click": function($event) {
        _vm.language = '简体中文'
      }
    }
  }, [_vm._v("简体中文")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "14-2"
    },
    on: {
      "click": function($event) {
        _vm.language = '繁体中文'
      }
    }
  }, [_vm._v("繁体中文")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "14-3"
    },
    on: {
      "click": function($event) {
        _vm.language = 'English'
      }
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "14-4"
    },
    on: {
      "click": function($event) {
        _vm.language = '한국어'
      }
    }
  }, [_vm._v("한국어")])], 2)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/title.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b46d817c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/header.vue
// module id = 668
// module chunks = 1